import { Stack, useMediaQuery, useTheme } from "@mui/material";
import Header from "../components/Header";
import DailySalesReportComponent from "../components/desktop/daily-sales-report/DailySalesReports";
import DailySalesReportMobileComponent from "../components/mobile/daily-sales-report/DailySalesReportsMobile";
import DailySalesReportErrorMessage from "../components/desktop/daily-sales-report/DailySalesReportErrorMessage";

type Props = {};

const DailySalesReport = (props: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Stack p={1} gap={2}>
      <Header title="Daily Sales Report" />
      {/* {isMobile ? (
        <DailySalesReportMobileComponent />
      ) : (
        <DailySalesReportComponent />
      )} */}
      <DailySalesReportErrorMessage />
    </Stack>
  );
};

export default DailySalesReport;
